import { useState } from "react";
import { useNavigate } from "react-router-dom";
import JourneyCard from "../home/journey/card/journeyCard";
import GASOLINEIMG from "../../assets/images/New1000EFIPetrol/1000EFI_new_doors_1_HD-removebg-preview.png";
import TU01 from "../../assets/png/TU01.png";
import TUSC01 from "../../assets/images/1500EFIImg/1500E-2__1500E-3__Title_photo-removebg-preview.png";
// import TU01 from "../../../assets/images/1500EFIImg/1500E-2__1500E-3__Title_photo-removebg-preview.png";
import { RouterPaths } from "../../router/router";
import SC2500E from "../../assets/images/SC2500E/SC2500E(1).jpg";
import Dualcab18 from "../../assets/images/Dualcab18.jpg";
import ContactFormModal from "../header/HomeHeader/contact/ContactFormModal";

const Models = () => {
  const navigate = useNavigate();
  const [contactOpen, setContactOpen] = useState(false);
  const JourneyList = [
    {
      title: "GASOLINE",
      subTitle: "TU-1000EFI-2",
      description: "A powerful 1000cc gas UTV built for heavy-duty work, featuring strong towing capacity, high payload performance, and reliable 4WD capability for tough terrain.",
      img: GASOLINEIMG,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.EFI,
      buttonText: "EXPLORE TU-1000EFI-2",
    },
    {
      title: "ELECTRIC",
      subTitle: "TU-1500E-2",
      description: "A quiet, efficient electric utility vehicle with a 15KW motor and 12KWh battery, ideal for farms, worksites, and low-emission environments.",
      img: TUSC01,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TU1500E2,
      buttonText: "EXPLORE TU-1500E-2",
    },
    {
      title: "ELECTRIC",
      subTitle: "TU-1500E-3",
      description: "A versatile 3-seat electric UTV designed for smooth, low-maintenance operation with strong torque and dependable performance across varied terrain.",
      img: TUSC01,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TU1500E3,
      buttonText: "EXPLORE TU-1500E-3",
    },
    // {
    //   title: "ELECTRIC",
    //   subTitle: "TU-1500E-4",
    //   img: TUSC01,
    //   Capacity: "2WD / 4WD",
    //   Models: 0,
    //   link: RouterPaths.TU1500E4,
    // },
    {
      title: "ELECTRIC DUAL MOTOR",
      subTitle: "SC2500E MODELS",
      description: "A high-performance dual motor electric UTV delivering enhanced power, traction, and control – perfect for demanding commercial and off-road applications.",
      img: SC2500E,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TUSC2500E1,
      buttonText: "EXPLORE SC2500E",
    },
    {
      title: "ELECTRIC",
      subTitle: "DC2500E MODELS",
      description: "A rugged electric 4WD utility vehicle built for durability, efficiency, and all-terrain capability; ideal for daily operations and heavy workloads.",
      img: Dualcab18,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TUDC2500E1,
      buttonText: "EXPLORE DC2500E",
    },
  ];
  return (
    <div className="bg-[#fff]">
      <div className="custom-container lg:pt-[90px] md:pt-[70px] sm:pt-[60px] pt-[50px] sm:pb-[60px] pb-[70px]">
        <div className="flex">
          <h2 className="font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold lg:border-b-[5px] sm:border-b-[2px] border-b-[2px] border-[#7ABF5B] ">
            FIND THE RIGHT UTV FOR THE WAY YOU WORK
          </h2>
        </div>
        <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[17px] sm:text-[16px] text-[14px] text-[#000] mt-[40px]">
          Tuatara is built for those who need a reliable partner both on the job and on the trail. With features like
          selectable 2WD or 4WD, front and rear differential locks, hydraulic clutch, manual transmission, and
          heavy-duty towing and payload capacities, Tuatara vehicles are engineered to handle everything from
          construction sites to outdoor expeditions.
        </div>

        <div className="mt-[40px]">
          <h3 className="font-[Rockwell] 2xl:text-[28px] xl:text-[24px] lg:text-[22px] md:text-[20px] sm:text-[18px] text-[16px] font-bold text-[#7ABF5B] mb-[16px]">
            Gas vs Electric UTVs
          </h3>
          <p className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[17px] sm:text-[16px] text-[14px] text-[#000] mb-[12px]">
            Choosing between a gas or electric UTV depends on how and where you work.
          </p>
          <p className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[17px] sm:text-[16px] text-[14px] text-[#000] mb-[12px]">
            <strong>Gas UTVs</strong> offer greater range and consistent power, making them ideal for heavy-duty tasks, long workdays, and remote locations.
          </p>
          <p className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[17px] sm:text-[16px] text-[14px] text-[#000] mb-[12px]">
            <strong>Electric UTVs</strong> provide quiet operation, lower running costs, and reduced maintenance – perfect for noise-sensitive environments, indoor facilities, and eco-conscious operations.
          </p>
          <p className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[17px] sm:text-[16px] text-[14px] text-[#000]">
            With Tuatara, you have the flexibility to choose the right solution for your needs.
          </p>
        </div>

        <div className="grid 2xl:grid-cols-3 xl:grid-cols-2 md:grid-cols-1 grid-cols-1 gap-8 lg:mt-[90px] md:mt-[70px] sm:mt-[60px] mt-[50px]">
          {JourneyList?.map((item) => {
            return <JourneyCard item={item} />;
          })}
        </div>

        {/* Built For Every Job */}
        <div className="lg:mt-[90px] md:mt-[70px] mt-[50px]">
          <h2 className="font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold lg:border-b-[5px] sm:border-b-[2px] border-b-[2px] border-[#7ABF5B] mb-[32px] w-fit">
            BUILT FOR EVERY JOB
          </h2>

          <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
            <div>
              <h3 className="font-[Rockwell] 2xl:text-[24px] xl:text-[22px] lg:text-[20px] md:text-[18px] sm:text-[16px] text-[15px] font-bold text-[#7ABF5B] mb-[12px]">
                Farm &amp; Agriculture
              </h3>
              <p className="font-[Roboto] 2xl:text-[18px] xl:text-[17px] lg:text-[16px] sm:text-[15px] text-[14px] text-[#000] leading-relaxed">
                Tuatara UTVs are ideal for farm work, from transporting tools and feed to navigating paddocks and rough terrain. With high payload and towing capacity, they're built to handle daily agricultural demands.
              </p>
            </div>

            <div>
              <h3 className="font-[Rockwell] 2xl:text-[24px] xl:text-[22px] lg:text-[20px] md:text-[18px] sm:text-[16px] text-[15px] font-bold text-[#7ABF5B] mb-[12px]">
                Construction &amp; Worksites
              </h3>
              <p className="font-[Roboto] 2xl:text-[18px] xl:text-[17px] lg:text-[16px] sm:text-[15px] text-[14px] text-[#000] leading-relaxed">
                Designed for commercial and construction use, Tuatara UTVs make it easy to move materials, equipment, and crews efficiently across busy job sites.
              </p>
            </div>

            <div>
              <h3 className="font-[Rockwell] 2xl:text-[24px] xl:text-[22px] lg:text-[20px] md:text-[18px] sm:text-[16px] text-[15px] font-bold text-[#7ABF5B] mb-[12px]">
                Property Maintenance
              </h3>
              <p className="font-[Roboto] 2xl:text-[18px] xl:text-[17px] lg:text-[16px] sm:text-[15px] text-[14px] text-[#000] leading-relaxed">
                Perfect for large properties and land management, Tuatara UTVs help streamline maintenance tasks like fencing, landscaping, and general upkeep.
              </p>
            </div>

            <div>
              <h3 className="font-[Rockwell] 2xl:text-[24px] xl:text-[22px] lg:text-[20px] md:text-[18px] sm:text-[16px] text-[15px] font-bold text-[#7ABF5B] mb-[12px]">
                Off-Road &amp; Recreation
              </h3>
              <p className="font-[Roboto] 2xl:text-[18px] xl:text-[17px] lg:text-[16px] sm:text-[15px] text-[14px] text-[#000] leading-relaxed">
                When the work is done, Tuatara UTVs are just as capable for off-road adventures, delivering reliable performance across trails, gravel, and rugged terrain.
              </p>
            </div>
          </div>
        </div>

        {/* Trusted By Operators */}
        <div className="lg:mt-[70px] md:mt-[50px] mt-[40px]">
          <h2 className="font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold lg:border-b-[5px] sm:border-b-[2px] border-b-[2px] border-[#7ABF5B] mb-[20px] w-fit">
            TRUSTED BY OPERATORS ACROSS INDUSTRIES
          </h2>
          <p className="font-[Roboto] 2xl:text-[18px] xl:text-[17px] lg:text-[16px] sm:text-[15px] text-[14px] text-[#000] leading-relaxed">
            From farmers and contractors to commercial operators, Tuatara UTVs are trusted for their durability, reliability, and performance in demanding environments.
          </p>
        </div>

        {/* Ready To Get To Work CTA */}
        <div className="lg:mt-[70px] md:mt-[50px] mt-[40px] mb-[60px] bg-[#F2F2F2] border border-[#292929] px-[40px] py-[50px] text-center rounded-xl"
          style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>
          <h2 className="font-[Rockwell] 2xl:text-[36px] xl:text-[32px] lg:text-[28px] md:text-[24px] sm:text-[20px] text-[17px] font-extrabold mb-[16px]">
            READY TO GET TO WORK?
          </h2>
          <p className="font-[Roboto] 2xl:text-[18px] xl:text-[17px] lg:text-[16px] sm:text-[15px] text-[14px] text-[#000] leading-relaxed mb-[32px]">
            Whether you're working on the farm, managing a job site, or tackling off-road terrain, there's a model ready to match your needs.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              // onClick={() => navigate("/dealers-portal")}
              className="border border-[#7ABF5B] text-[#7ABF5B] px-8 py-3 font-[Roboto] font-semibold uppercase lg:text-[16px] text-[13px] hover:bg-[#7ABF5B] hover:text-white transition"
            >
              Find a Dealer
            </button>
            <button
              // onClick={() => setContactOpen(true)}
              className="border border-[#7ABF5B] text-[#7ABF5B] px-8 py-3 font-[Roboto] font-semibold uppercase lg:text-[16px] text-[13px] hover:bg-[#7ABF5B] hover:text-white transition"
            >
              Request a Quote
            </button>
          </div>
        </div>

        <ContactFormModal
          open={contactOpen}
          handleClose={() => setContactOpen(false)}
        />

      </div>
    </div>
  );
};
export default Models;
